// Басқа адамның жазбасындағы «⋯» → Шағымдану · Бұғаттау (Apple 1.2).
// Рендерлер тек ugcBtn(kind, id, authorId) HTML-ін қосады; басу — осындағы бір делегат.
// Өз жазбаңда батырма шықпайды. Оверлей адамның өз әрекетінен → ui-queue.
import { busyStart, busyEnd } from '../../core/ui-queue.js';

const Q = 'ugc-menu';
const REASONS = [['spam', 'Спам не жарнама'], ['abuse', 'Қорлау, жеккөрушілік'], ['spoiler', 'Белгісіз спойлер'], ['other', 'Басқа']];
let myId = null;
let installed = false;

export function setMyId(id) { myId = id == null ? null : Number(id); }

export function ugcBtn(kind, id, authorId) {
  install();
  if (authorId != null && myId != null && Number(authorId) === myId) return '';
  return `<button type="button" class="ugc-more" aria-label="Тағы" data-ugc-kind="${kind}" data-ugc-id="${id}" data-ugc-author="${authorId ?? ''}">⋯</button>`;
}

function css() {
  const s = document.createElement('style');
  s.textContent = `
  .ugc-more{margin-left:auto;border:0;background:none;color:var(--ink4,#96897A);font-size:18px;line-height:1;padding:2px 6px;cursor:pointer;border-radius:8px}
  .ugc-more:hover,.ugc-more:focus-visible{background:color-mix(in srgb,var(--ink) 8%,transparent)}
  .ugc-ov{position:fixed;inset:0;z-index:9100;background:rgba(10,8,6,.45);display:grid;align-items:end;justify-items:center}
  .ugc-sh{width:min(480px,100%);background:var(--bg);color:var(--ink);border-radius:18px 18px 0 0;
    padding:16px 16px calc(20px + env(safe-area-inset-bottom,0px));display:grid;gap:8px;font-family:"PT Sans",system-ui,sans-serif}
  .ugc-sh h3{margin:0 0 4px;font:700 17px "PT Serif",Georgia,serif}
  .ugc-sh button{text-align:left;padding:12px 14px;border-radius:12px;border:1px solid color-mix(in srgb,var(--ink) 12%,transparent);
    background:transparent;color:var(--ink);font:500 15px inherit;cursor:pointer}
  .ugc-sh .ugc-danger{color:#A6472E}
  .ugc-sh p{margin:0;font-size:14px;color:var(--ink2,#4A443B)}`;
  document.head.appendChild(s);
}

function install() {
  if (installed) return;
  installed = true;
  css();
  fetch('/api/auth/me', { credentials: 'include' }).then(r => r.json()).then(j => { if (j?.authenticated) setMyId(j.telegram_id); }).catch(() => {});
  document.addEventListener('click', e => {
    const b = e.target.closest('.ugc-more');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b.dataset.ugcKind, b.dataset.ugcId, b.dataset.ugcAuthor, b);
  }, true);
}

async function post(url, body, method = 'POST') {
  const r = await fetch(url, { method, credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  return r.ok;
}

function open(kind, id, author, btn) {
  try { busyStart(Q); } catch (_) {}
  const ov = document.createElement('div');
  ov.className = 'ugc-ov';
  const close = () => { ov.remove(); try { busyEnd(Q); } catch (_) {} };
  const sh = document.createElement('div');
  sh.className = 'ugc-sh';
  sh.setAttribute('role', 'dialog');
  ov.appendChild(sh);
  const main = () => {
    sh.innerHTML = `<h3>Бұл жазба</h3>
      <button data-x="report">Шағымдану</button>
      ${author ? '<button data-x="block" class="ugc-danger">Авторды бұғаттау</button>' : ''}
      <button data-x="close">Болдырмау</button>`;
  };
  main();
  ov.addEventListener('click', async e => {
    if (e.target === ov) return close();
    const x = e.target.closest('[data-x]')?.dataset.x;
    if (!x) return;
    if (x === 'close') return close();
    if (x === 'report') {
      sh.innerHTML = `<h3>Неге шағымданасың?</h3>${REASONS.map(([k, t]) => `<button data-x="r:${k}">${t}</button>`).join('')}<button data-x="close">Болдырмау</button>`;
    } else if (x.startsWith('r:')) {
      const ok = await post('/api/ugc/report', { kind, item_id: id, author_id: author || null, reason: x.slice(2) });
      sh.innerHTML = ok
        ? '<h3>Рақмет</h3><p>Шағымың модераторға жетті. 24 сағат ішінде қараймыз.</p><button data-x="close">Жабу</button>'
        : '<h3>Жіберілмеді</h3><p>Кіріп, қайта байқап көр.</p><button data-x="close">Жабу</button>';
    } else if (x === 'block') {
      sh.innerHTML = `<h3>Авторды бұғаттау</h3><p>Оның пікірлері, дәйексөздері мен жазбалары саған енді көрінбейді. Кейін Баптаулардан қайтара аласың.</p>
        <button data-x="block-yes" class="ugc-danger">Бұғаттау</button><button data-x="close">Болдырмау</button>`;
    } else if (x === 'block-yes') {
      const ok = await post('/api/ugc/block', { user_id: Number(author) });
      if (ok) {
        document.querySelectorAll(`.ugc-more[data-ugc-author="${CSS.escape(author)}"]`).forEach(m => {
          const card = m.closest('.review-item, .quote-box, .msg, .gr-talq-post, .gr-talq-reply, .refl-card');
          if (card) card.remove();
        });
        sh.innerHTML = '<h3>Бұғатталды</h3><p>Енді оның жазбалары саған көрінбейді.</p><button data-x="close">Жабу</button>';
      } else {
        sh.innerHTML = '<h3>Болмады</h3><p>Кіріп, қайта байқап көр.</p><button data-x="close">Жабу</button>';
      }
    }
  });
  document.body.appendChild(ov);
}
